// Import model
import { CreateMessageRequest } from '../models/CreateMessageRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateMessageRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateMessageRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateMessageRequest instance
   */
  static deserialize(json: string): CreateMessageRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateMessageRequest instance
   */
  static fromObject(obj: any): CreateMessageRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateMessageRequest');
    }


    const instance: CreateMessageRequest = {
      role: obj['Role'] as string | undefined,
      text: obj['Text'] as string | undefined,
      contentType: obj['ContentType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateMessageRequest instances
   */
  static deserializeArray(json: string): CreateMessageRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateMessageRequest instance to a JSON string
   */
  static serialize(instance: CreateMessageRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateMessageRequest instance to a plain object
   */
  static toObject(instance: CreateMessageRequest): any {
    return {
      'Role': instance.role,
      'Text': instance.text,
      'ContentType': instance.contentType,
    };
  }

  /**
   * Serializes an array of CreateMessageRequest instances to a JSON string
   */
  static serializeArray(instances: CreateMessageRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
